<template>
  <div class="border border-1 rounded-3 p-3 mb-2">
    <div class="d-flex justify-content-end mt-3 mx-2">
      <div
        class="d-flex align-items-center px-3 py-2 bg-primary bg-opacity-10 border border-primary rounded-3 shadow-sm"
      >
        <i class="bi bi-people-fill text-primary fs-5 me-2"></i>
        <span class="fw-bold text-primary">
          Total de trabajadores: {{ totalItems }}
        </span>
      </div>
    </div>

    <div class="tab-content mt-3">
      <div class="mt-2 mx-3 table-responsive">
        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
              <th colspan="1"></th>
              <th colspan="5">DATOS GENERALES</th>
              <th colspan="8">CESE</th>
            </tr>

            <tr class="bg-solimano text-white text-center text-nowrap">
              <th scope="col">ESTADO</th>
              <th scope="col">CLIENTE</th>
              <th scope="col">TRABAJADOR</th>
              <th scope="col">CONTRATO ACTUAL</th>
              <th scope="col">TAREO DIARIO</th>
              <th scope="col">BONIFICACIONES</th>
              <th scope="col">DESCUENTOS</th>
              <th scope="col">HORAS EXTRAS</th>
              <th scope="col">MOVILIDAD</th>
              <th scope="col">FECHA / MOTIVO</th>
              <th scope="col">DOC. ADJUNTO</th>
              <th scope="col">COMENTARIO</th>
            </tr>
          </thead>
          <tbody class="align-middle">
            <tr
              class="text-center align-middle reducirTamaño"
              v-for="itema in items"
              :key="itema.idCese"
            >
             

              <td class="text-start fw-bold align-middle" style="width: 150px">
                <div class="mb-1">{{ itema.periodo }}</div>

                <span
                  class="badge px-2 py-1"
                  :class="{
                    'bg-primary': itema.cesCodEstado == 'EN PROCESO',
                    'bg-warning text-dark': itema.cesCodEstado == 'SOLICITADO',
                    'bg-danger': itema.renCodEstado == 'NO RENOVADO',
                  }"
                >
                  {{ itema.cesCodEstado }}
                </span>
              </td>

              <td class="text-start align-middle" style="width: 300px">
                <div class="fw-semibold text-primary">{{ itema.nomEmpresa }}</div>
                <div class="text-muted small">{{ itema.subCentroCostos }}</div>
                <div class="text-muted small">{{ itema.subSubCentroCostos }}</div>
              </td>

              <td class="text-start fw-bold align-middle" style="width: 300px">
                <div class="text-secondary">[ {{ itema.codTrabajador }} ]</div>
                <div>{{ itema.nroDocumento }}</div>
                <div class="text-primary">{{ itema.nomTrabajador }}</div>
              </td>

              <td class="text-center text-nowrap align-middle" style="width: 260px">
                <div class="fw-semibold text-primary mb-1">
                  {{ itema.nomPuesto }}
                </div>

                <div class="small">
                  <i class="bi bi-calendar-event text-primary"></i>
                  {{ new Date(itema.fechaIniContrato).toLocaleDateString('es-ES') }}
                  -
                  {{ new Date(itema.fechaFinContrato).toLocaleDateString('es-ES') }}
                </div>

                <div class="small mt-1">
                  <span class="fw-bold">Sueldo: </span>{{ itema.cesSueldo }}
                </div>

                <div class="small">
                  <span class="fw-bold">Asig. Familiar: </span>{{ itema.asignacionFamiliar }}
                </div>
              </td>

              <td class="text-start fw-bold text-primary align-middle" style="width: 200px">
                <div class="d-flex justify-content-between small">
                  <span>Días Trab.:</span> <span>{{ itema.diasTrabajados }}</span>
                </div>

                <div class="d-flex justify-content-between small">
                  <span>Faltas:</span> <span>{{ itema.diasFaltas }}</span>
                </div>

                <div class="d-flex justify-content-between small">
                  <span>Desc. Médico:</span> <span>{{ itema.diasDescansoMedico }}</span>
                </div>

                <div
                  class="border-top mt-1 pt-1 d-flex justify-content-between small fw-bold"
                >
                  <span>Total:</span> <span>{{ itema.totalDias }}</span>
                </div>
              </td>

              <td class="text-start fw-bold text-primary align-middle" style="width: 200px">
                <div class="d-flex justify-content-between small">
                  <span>Aguinaldo:</span> <span>{{ itema.aguinaldo }}</span>
                </div>

                <div class="d-flex justify-content-between small">
                  <span>Alimentos:</span> <span>{{ itema.alimentos }}</span>
                </div>

                <div class="d-flex justify-content-between small">
                  <span>B. Nocturno:</span> <span>{{ itema.bonoNocturno }}</span>
                </div>

                <div class="d-flex justify-content-between small">
                  <span>B. Regular:</span> <span>{{ itema.bonoRegular }}</span>
                </div>

                <div class="d-flex justify-content-between small">
                  <span>Comisión:</span> <span>{{ itema.comision }}</span>
                </div>
              </td>

              <td class="text-center align-middle" style="width: 220px">
                <div class="d-flex flex-column gap-2">
                  <button
                    class="btn btn-outline-primary boton-EstiloCuadrado reducirTamaño w-100"
                    @click="
                      $emit(
                        'navigate-to-descuento',
                        itema.idTrabajador,
                        16
                      )
                    "
                  >
                    BIENESTAR: {{ itema.desBienestar }}
                  </button>

                  <button
                    class="btn btn-outline-warning boton-EstiloCuadrado reducirTamaño w-100"
                    @click="
                      $emit(
                        'navigate-to-descuento',
                        itema.idTrabajador,
                        7
                      )
                    "
                  >
                    CONTABILIDAD: {{ itema.desContabiliad }}
                  </button>

                  <button
                    class="btn btn-outline-danger boton-EstiloCuadrado reducirTamaño w-100"
                    @click="
                      $emit(
                        'navigate-to-descuento',
                        itema.idTrabajador,
                        5
                      )
                    "
                  >
                    TECNOLOGÍA: {{ itema.desTecnologia }}
                  </button>
                </div>
              </td>

              <!-- HORAS EXTRA -->
              <td class="text-start fw-bold text-primary align-middle" style="width: 180px">
                <div class="d-flex justify-content-between small">
                  <span>Hr.Ext. 25%:</span>
                  <span>{{ itema.horaExtra25 }}</span>
                </div>

                <div class="d-flex justify-content-between small">
                  <span>Hr.Ext. 35%:</span>
                  <span>{{ itema.horaExtra35 }}</span>
                </div>

                <div class="d-flex justify-content-between small">
                  <span>Hr.Ext. 50%:</span>
                  <span>{{ itema.horaExtra50 }}</span>
                </div>

                <div class="d-flex justify-content-between small">
                  <span>Hr.Ext. 100%:</span>
                  <span>{{ itema.horaExtra100 }}</span>
                </div>
              </td>

              <td class="text-start fw-bold text-primary align-middle" style="width: 160px">
                <div class="d-flex justify-content-between small">
                  <span>Mov. 100%:</span>
                  <span>{{ itema.movilidad }}</span>
                </div>

                <div class="d-flex justify-content-between small">
                  <span>Mov. Extra:</span>
                  <span>{{ itema.movilidadExtra }}</span>
                </div>
              </td>

              <td class="text-center align-middle" style="width: 160px">
                <div class="small fw-bold">
                  {{ new Date(itema.fechaCese).toLocaleDateString('es-ES') }}
                </div>

                <div class="small text-secondary mt-1">
                  <span v-if="itema.motivoCese.length > 0">
                    {{ itema.motivoCese }}
                  </span>
                  <span v-else>-</span>
                </div>
              </td>

              <td class="align-middle small" style="width: 140px">
                {{ itema.cesEstadoAdjunto ? 'ADJUNTO CARGADO' : 'SIN ADJUNTO' }}
                <a
                  :href="itema.cesAdjunto"
                  v-if="itema.cesEstadoAdjunto"
                  class="btn btn-danger"
                  target="_blank"
                  rel="noopener"
                >
                  <i class="bi bi-file-earmark-pdf text-white fs-7"></i>
                </a>
              </td>

              <td class="align-middle sm*-all" style="width: 200px">
                {{ itema.comentario }}
              </td>

            
            </tr>
          </tbody>
        </table>
        <div
          v-if="totalPages > 1"
          class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3"
        >
          <button
            class="btn btn-outline-primary btn-sm"
            @click="$emit('update:currentPage', 1)"
            :disabled="currentPage === 1"
          >
            <i class="bi bi-chevron-double-left"></i>
          </button>

          <button
            class="btn btn-outline-primary btn-sm"
            @click="$emit('update:currentPage', currentPage - 1)"
            :disabled="currentPage === 1"
          >
            <i class="bi bi-chevron-left"></i>
          </button>

          <span class="pagination-info fw-semibold">
            Página {{ currentPage }} de {{ totalPages }}
          </span>

          <button
            class="btn btn-outline-primary btn-sm"
            @click="$emit('update:currentPage', currentPage + 1)"
            :disabled="currentPage === totalPages"
          >
            <i class="bi bi-chevron-right"></i>
          </button>

          <button
            class="btn btn-outline-primary btn-sm"
            @click="$emit('update:currentPage', totalPages)"
            :disabled="currentPage === totalPages"
          >
            <i class="bi bi-chevron-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SegCeseTable',
  props: {
    items: {
      type: Array,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    fromIdCese: { // This prop is needed for the disableRegistroButton logic
      type: String, // Assuming idCese is a string
      default: ''
    }
  },
  methods: {
   
  }
};
</script>

<style scoped>
.boton-EstiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;
}

.reducirTamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #1565C0;
}
</style>